import React from "react";
import PropTypes from "prop-types";
import {Divider} from "spectre-react/dist/cjs";
import CalculationString from "./CalculationString";
import {COEFF_INFO, STATUS_DESCRIPTION} from "./shared";
import {dmyHmFmt} from "../../shared/utils";


// TODO: разделить "отпускные/больничный" на "отпускные" и "больничный"


class ManagerDayContent extends React.PureComponent {
    static propTypes = {
        timelineDay: PropTypes.object,
    }

    render() {
        const isTimelineDaySelected = !!this.props.timelineDay;
        const timelineDay = {...this.props.timelineDay};

        if (!timelineDay)
            return null;

        for (const key in timelineDay) {
            if (typeof timelineDay[key] === "number")
                timelineDay[key] = timelineDay[key].toFixed(2);
        }

        return (
            <div id="day-content" className="text-preline">
                {!isTimelineDaySelected && <div>Выберите день.</div>}

                {isTimelineDaySelected && <div>Статус: {STATUS_DESCRIPTION[timelineDay.status]}</div>}
                {isTimelineDaySelected && <div>Начислено всего: {timelineDay.payAmount} ₽</div>}

                {timelineDay.workHoursSum > 0 && (
                    <div>
                        <Divider />

                        <div>Регулярные рабочие часы: {timelineDay.workHoursRegular} ч</div>
                        <div>Сверхурочные рабочие часы: {timelineDay.workHoursOvertime} ч</div>
                        <div>Всего рабочих часов: {timelineDay.workHoursSum} ч</div>
                        <div>Начислено за рабочие часы: {timelineDay.workHoursPayAmount} ₽</div>
                        <div>Репорты: {timelineDay.reportIds.map(([reportId, clientName], i) => <span key={reportId}>{i > 0 && ", "}<a href={`/reports/${reportId}/edit`}>{clientName}</a></span>)}</div>
                        <CalculationString key={timelineDay.workHoursCalc} coeffInfo={COEFF_INFO.work} string={timelineDay.workHoursCalc} />
                    </div>
                )}

                {timelineDay.complementHoursSum > 0 && (
                    <div>
                        <Divider />

                        <div>Дополнительные регулярные рабочие часы: {timelineDay.complementHoursRegular} ч</div>
                        <div>Дополнительные сверхурочные рабочие часы: {timelineDay.complementHoursOvertime} ч</div>
                        <div>Всего дополнительных часов: {timelineDay.complementHoursSum} ч</div>
                        <div>Начислено дополнительно: {timelineDay.complementHoursPayAmount} ₽</div>
                        <CalculationString key={timelineDay.complementHoursCalc} coeffInfo={COEFF_INFO.complement} string={timelineDay.complementHoursCalc} />
                    </div>
                )}

                {timelineDay.holidayBonusPayAmount > 0 && (
                    <div>
                        <Divider />

                        <div>Праздничный день на буднях: {timelineDay.holidayBonusPayAmount} ₽</div>
                    </div>
                )}

                {timelineDay.workTripBonusPayAmount > 0 && (
                    <div>
                        <Divider />

                        <div>Бонус за командировку: {timelineDay.workTripBonusPayAmount} ₽</div>
                    </div>
                )}

                {timelineDay.travelHoursSumVirtual > 0 && (
                    <div>
                        <Divider />

                        <div>Реальных часов в дороге: {timelineDay.travelHoursSumReal} ч</div>
                        <div>Виртуальных часов в дороге: {timelineDay.travelHoursSumVirtual} ч</div>
                        <div>Регулярные часы в дороге: {timelineDay.travelHoursRegular} ч</div>
                        <div>Сверхурочные часы в дороге: {timelineDay.travelHoursOvertime} ч</div>
                        <div>Всего часов в дороге: {timelineDay.travelHoursSumVirtual} ч</div>
                        <div>Начислено за время в дороге: {timelineDay.travelHoursPayAmount} ₽</div>
                        <CalculationString key={timelineDay.travelHoursCalc} coeffInfo={COEFF_INFO.travel} string={timelineDay.travelHoursCalc} />
                    </div>
                )}

                {timelineDay.vacationPayAmount > 0 && (
                    <div>
                        <Divider />
                        <div>Отпускные: {timelineDay.vacationPayAmount} ₽</div>
                    </div>
                )}

                {timelineDay.illnessPayAmount > 0 && (
                    <div>
                        <Divider />
                        <div>Больничный: {timelineDay.illnessPayAmount} ₽</div>
                    </div>
                )}

                {timelineDay.manualBonusPayAmount > 0 && (
                    <div>
                        <Divider />
                        <div>Ручной бонус: {timelineDay.manualBonusPayAmount} ₽</div>
                    </div>
                )}

                {timelineDay.updatedAt && (
                    <div>
                        <Divider />
                        <div className="text-italic">Обновлено: {dmyHmFmt(new Date(timelineDay.updatedAt))}</div>
                    </div>
                )}
            </div>
        );
    }
}

export default ManagerDayContent;